import { DataFilter } from '@siclop/kstone-vue'

export class PublicHolidayFilter extends DataFilter {
  code?: string
  year?: number
  isRecurring?: boolean

  constructor(data?: Partial<PublicHolidayFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.year = data.year
      this.isRecurring = data.isRecurring
    }
  }
}
